class AbstractIntegrationController extends AbstractController
	@inject '$filter',
		'$state'
		'$stateParams'
		'integrations'
		'IntegrationRepository'
		'ToastService'
		'LEGACY_INTEGRATIONS'
		'MessageTerminal'

	$onInit: ->
		@showFormActionButtons = true
		@additionalButtonsTemplate = null

		@isLegacy = @LEGACY_INTEGRATIONS.includes(@integrationId)
		@actions =
			connect: true
			disconnect: true
			save: true
		@headerText = "wbo.integration.#{@integrationId}.header"

		if !@integrationId?
			throw new Error('Integration controller ' + @constructor.name + ' must have integrationId defined')

		return if @ensureOnProperPage()

		@updating = @isConnected()
		@saving = false

		super(...arguments)

		@loaded = true

	ensureObjectsInConfiguration: (configuration = {}, keys) ->
		for key in keys
			if _.isEmpty(configuration[key])
				configuration[key] = {}

	ensureOnProperPage: ->
		if @isLegacy
			if !@isConnected() && @$stateParams.action != 'connect'
				@goToConnectPage()

				return true

			if @isConnected() && @$stateParams.action == 'connect'
				@goToConfigPage()

				return true
		else if @$stateParams.action == 'connect'
			@goToConfigPage()

			return true

		return false

	goToConnectPage: ->
		if @isLegacy
			@$state.go('integrations.integration.details', {action: 'connect', id: @integrationId})
		else
			@goToConfigPage()

	goToConfigPage: (parameters = {}) ->
		@$state.go('integrations.integration.details', _.extend({action: 'config', id: @integrationId}, parameters))

	isConnected: (integrationId = @integrationId) ->
		integration = _.find(@integrations, {id: integrationId})

		return integration? && integration.is_connected

	connect: (data = null) ->
		if @isConnected()
			@goToConfigPage()

			return

		@resetErrors()

		@IntegrationRepository
			.save {api_integration_id: @integrationId, data: data}
			.then =>
				@resetForm()
				@setConnectedStatus true
				@afterConnect?()
				@goToConfigPage() if @isLegacy

	disconnect: ->
		@resetErrors()

		@IntegrationRepository
			.delete(@integrationId)
			.then =>
				@resetForm()
				@setConnectedStatus false
				@ToastService.add(
					@$filter('translate')(@headerText).toString(),
					@$filter('translate')('general.integration'),
					@$filter('translate')('alert.deleted'),
					'success'
				)
				@afterDisconnect?()
				@goToConnectPage() if @isLegacy

	save: (data, withAttachments = false) ->
		@saving = true
		@resetErrors()

		return @IntegrationRepository
			.saveConfiguration @integrationId, data, @updating, withAttachments
			.then (response) =>
				@resetForm()
				@ToastService.add(
					@$filter('translate')(@headerText).toString(),
					@$filter('translate')('general.integration'),
					@$filter('translate')('alert.updated'),
					'success'
				)
				@setConnectedStatus true
				@MessageTerminal.afterSave !@updating, data
				@updating = true

				return response
			.catch (response) =>
				@handleErrors(response)

				@ToastService.add(
					if response.data?.error? then response.data.error else @$filter('translate')(@headerText).toString(),
					@$filter('translate')('general.integration'),
					@$filter('translate')('general.error'),
					'error'
				)

				return Promise.reject(response)
			.finally =>
				@saving = false

	setConnectedStatus: (status) ->
		integration = _.find(@integrations, {id: @integrationId})
		integration.is_connected = status

		@updating = status

	resetForm: ->
		@mainForm?.$setPristine()
		@mainForm?.$setUntouched()
